export default import.meta.ROLLDOWN_FILE_URL_aIAMF20UzD_VyQXe4EAsmA